/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2018, Zumper
 * @description  Router middleware for dispatching traktor events
 */

import { selectIsBot } from '@zcode-ui/web-zumper-global-state'
import { createTraktorMiddleware as __createTraktorMiddleware } from '@zcode/integrations'
import {
  type LocalStorage,
  getGclidFromLocalStorage,
  getMsclkidFromLocalStorage,
} from '@zcode/legacy-local-storage'
import { localStorageSingleton } from '@zcode/nr-utils'
import type { ExtraThunkArg, State } from '@zcode/state-type'
import { trackOptimizelyTraktorEvents } from '../optimizely-events'

const _createTraktorMiddleware = __createTraktorMiddleware<State, LocalStorage, ExtraThunkArg>

export const createTraktorMiddleware = (
  siteActions: NonNullable<Parameters<typeof _createTraktorMiddleware>[0]['siteActions']>,
  trackCallback?: Parameters<typeof _createTraktorMiddleware>[0]['trackCallback']
) => {
  return _createTraktorMiddleware({
    getMsclkidFromLocalStorage,
    getGclidFromLocalStorage,
    localStorageSingleton,
    selectIsBot,
    siteActions,
    trackCallback,
    trackOptimizelyTraktorEvents,
  })
}
